// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"_1OSEJ","infoBox--critical":"_1EOWO","description":"AF42F","icon":"_1LJad","icon--critical":"_2adGT","centered":"_35lcC","noLeftMargin":"EQ9r9"};